//  drag滑动效果
export const drag = {
  bind: function(el) {
    var odic = el
    var firstTime = ''
    var lastTime = ''
    odic.setAttribute('data-flag', false)
    odic.onmousedown = (e) => {
      firstTime = new Date().getTime()
      var tY = e.clientY
      var tX = e.clientX
      var odicRect = odic.getBoundingClientRect()
      var offsetH = odic.offsetHeight
      var offsetW = odic.offsetWidth
      var clientW = document.documentElement['clientWidth']
      var clientH = document.documentElement['clientHeight']
      var rect = null
      document.onmousemove = (event) => {
        let moveX = event.clientX
        let moveY = event.clientY
        let left
        let top
        left = moveX - tX
        top = moveY - tY
        odic.style.left = odicRect.x + left + 'px'
        odic.style.top =
          odicRect.y + top < 0
            ? '0px'
            : odicRect.y + top > clientH - offsetH
            ? clientH - offsetH + 'px'
            : odicRect.y + top + 'px'
        //  阻止默认事件派发
        event.stopPropagation()
        event.preventDefault()
      }
      document.onmouseup = (e) => {
        lastTime = new Date().getTime()
        //  时间差
        if (lastTime - firstTime < 300) {
          odic.setAttribute('data-flag', true)
          setTimeout(() => {
            odic.setAttribute('data-flag', false)
          }, 300)
        }
        //  清除内存
        ;[lastTime, firstTime, document.onmousemove, document.onmouseup] = [
          null,
          null,
          null,
          null
        ]
      }
    }
  }
}

// drags滑动效果 (弹框滑动)
export const drags = {
  bind: function(el) {
    var odic = el
    var firstTime = ''
    var lastTime = ''
    odic.setAttribute('data-flag', false)
    odic.onmousedown = (e) => {
      firstTime = new Date().getTime()
      var tY = e.clientY
      var tX = e.clientX
      var odicRect = odic.getBoundingClientRect()
      var offsetH = odic.offsetHeight
      var offsetW = odic.offsetWidth
      var clientW = document.documentElement['clientWidth']
      var clientH = document.documentElement['clientHeight']
      var rect = null
      rect = [
        odicRect.x,
        odicRect.y,
        -clientW + offsetW + odicRect.x,
        -clientH + offsetH + odicRect.y
      ]
      document.onmousemove = (event) => {
        let moveX = event.clientX
        let moveY = event.clientY
        let left
        let top
        left = moveX - tX
        top = moveY - tY
        odic.parentNode.style.left = odicRect.x + left + 'px'
        odic.parentNode.style.top =
          odicRect.y + top < 0
            ? '0px'
            : odicRect.y + top > clientH - offsetH
            ? clientH - offsetH + 'px'
            : odicRect.y + top + 'px'
        // odicRect.y + top + 'px'
        //  阻止默认事件派发
        event.stopPropagation()
        event.preventDefault()
      }
      document.onmouseup = (e) => {
        lastTime = new Date().getTime()
        //  时间差
        if (lastTime - firstTime < 100) {
          odic.setAttribute('data-flag', true)
          setTimeout(() => {
            odic.setAttribute('data-flag', false)
          }, 100)
        }
        //  清除内存
        ;[lastTime, firstTime, document.onmousemove, document.onmouseup] = [
          null,
          null,
          null,
          null
        ]
      }
    }
  }
}
